import React from 'react';
import styled from 'styled-components';
import { white, gray } from '@avangard/ui/colors';

import { Loader } from '@modules/layout/moleculas';

type DashboardCardProps = {
    children: React.ReactNode;
    loading?: boolean;
    className?: string;
};

const Root = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    min-height: 100px;
    padding: 16px;
    background: ${white[100]};
    border: 1px solid ${gray[40]};
    border-radius: 4px;
`;

const DashboardCard = (props: DashboardCardProps): React.ReactElement => {
    const { loading = false, className, children } = props;

    if (loading) {
        return (
            <Root className={className}>
                <Loader />
            </Root>
        );
    }

    return <Root className={className}>{children}</Root>;
};

export { DashboardCard };
